export const Span = ({ content, ...props }: { content: Array<string> }) => {
  return content.map((ele: string, index: number) => (
    <span
      key={index}
      className={`${index == content.length - 1 ? null : 'mb-2'}`}
      {...props}
    >
      {ele}
    </span>
  ));
};
